const tileData = [
  {
    img: 'https://images.pexels.com/photos/846741/pexels-photo-846741.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    title: 'Image',
    author: 'author',
    cols: 2,
  },
  {
    img: 'https://images.pexels.com/photos/935867/pexels-photo-935867.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    title: 'Image',
    author: 'author',
  },
  {
    img: 'https://images.pexels.com/photos/380283/pexels-photo-380283.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    title: 'Image',
    author: 'author',
    cols: 3,
  },
];

export default tileData;